import React from "react";
// import emailjs from 'emailjs-com';
import "./ContactForm.css";
import img1 from "../../Assets/5124556.jpg";
import { ToastContainer, toast } from "react-toastify";




const ContactForm = () => {
  const onSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);

    formData.append("access_key", "ee8fa2ec-efa3-4347-a8ac-cbc23c369239");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
        toast.success('Login successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            // transition: Bounce,
            });

    } else {
        toast("Message not sent");
       
    }
  };

  return (
    <>
      <section className="contact" id="contact">
        <div className="container">
          <div className="heading text-center">
            <h2>
              Contact
              <span> Us </span>
            </h2>
            <p>
              You may reach us by email, a call, WhatsApp or through <br /> our
              social media channels
            </p>
          </div>
          <div className="row">
            <div className="col-md-5">
              <img src={img1} alt="" className="img-of-contact" srcset="" />
            </div>
            <div className="col-md-7 mt-3">
              <form onSubmit={onSubmit}>
                {/* onSubmit={handleSubmit} */}
                <div className="row">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      id="name"
                      name="name"
                      // value={formData.name}
                      // onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      id="email"
                      name="email"
                      //  value={formData.email}
                      //  onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-sm-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Subject"
                      id="subject"
                      name=" subject"
                      //  value={formData.subject}
                      //  onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                {/* <div className='form-group'>
                  <input type="tel" name=" phone" id="" />
                </div> */}
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows={5}
                    placeholder="Message"
                    id="message"
                    name="message"
                    //  value={formData.message}
                    //  onChange={handleChange}
                    required
                  />
                </div>
                <button className="btn btn-block" type="submit">
                  Send Now!
                </button>
              </form>
            </div>
          </div>
        </div>
        <ToastContainer/>
      </section>
    </>
  );
};

export default ContactForm;
